import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

const DividendsOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    {
      key: 'partner',
      content: t('Partner'),
    },

    {
      key: 'ndPercentage',
      content: t('%ND'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'retentionPercentage',
      content: t('%Retention'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'grossAmount',
      content: t('GrossAmount'),
      textPosition: 'right',
      hideOnMobile: true,
    },

    {
      key: 'toPerceive',
      content: t('ToPerceive'),
      textPosition: 'right',
    },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default DividendsOperationTableHeader;
